import { Box, Typography } from "@mui/material";
import useColors from "../../../api/hooks/useColors";
import LoadingIcon from "../../../components/LoadingIcon";
import { categorizeNotifications } from "../../../utils/timestamp";
import InboxNotificationRow from "./InboxNotificationRow";

const InboxNotificationList = ({ inAppNotifications, isLoading }) => {
  const colors = useColors();

  const categorizedNotifications = categorizeNotifications(inAppNotifications);

  return (
    <Box
      sx={{
        padding: "4px 0",
        borderRadius: "5px",
        overflowY: "auto",
        height: "100%",
      }}
    >
      {isLoading ? (
        <LoadingIcon size={25} />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {categorizedNotifications.today.length > 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  paddingLeft: "16px",
                  color: colors.text_secondary,
                }}
              >
                Today
              </Typography>
              {categorizedNotifications.today.map((notification, index) => (
                <InboxNotificationRow key={index} notification={notification} />
              ))}
            </Box>
          )}
          {categorizedNotifications.week.length > 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  paddingLeft: "16px",
                  color: colors.text_secondary,
                }}
              >
                This week
              </Typography>
              {categorizedNotifications.week.map((notification, index) => (
                <InboxNotificationRow key={index} notification={notification} />
              ))}
            </Box>
          )}
          {categorizedNotifications.older.length > 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  paddingLeft: "16px",
                  color: colors.text_secondary,
                }}
              >
                Older
              </Typography>
              {categorizedNotifications.older.map((notification, index) => (
                <InboxNotificationRow key={index} notification={notification} />
              ))}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default InboxNotificationList;
